import { useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import Card from "shared/Card";
import { useForm } from "react-hook-form";
import PaymentForm from "../PageCheckout/PaymentForm";
import BillingAddressForm from "../PageCheckout/BillingAddress";
import toast from "react-hot-toast";
import { Transition } from "@headlessui/react";
import appConfig from "configs/app.config";
import axios, { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import {
  loadAcceptJs,
  tokenizeCardWithAcceptJs,
  tokenizeCardWithAcceptJsWithCredentials,
  getBasilCredentials,
  parseExpiration,
} from "utils/acceptJs";
interface Cards {
  payment: {
    creditCard: {
      cardNumber: string;
      cardType: string;
      expirationDate: string;
      
    };
  };
  billTo: {
    customerId: string;
    firstName: string;
    lastName: string;
    profileId: string;
    address: string;
    city: string;
    state: string;
    zip: string;
  };
  customerPaymentProfileId: string;
}
type CardData = {
  cardNumber: string;
  cardType: string;
  expirationDate: string;
  firstName: string;
  lastName: string;
  profileId: string;
  address: string;
  city: string;
  state: string;
  zip: string;
};

const AccountSavelist = () => {
  const [user, setUser] = useState(Cookies.get("user")??"");
  const [auth, setAuth] = useState<Cards[]>([]);
  const [phonee, setPhone] = useState("");
  const [useremail, setUseremail] = useState("");
  const [cards, setCards] = useState<CardData[]>([]);
  const [showCardField, setShowCardField] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const userDataString = Cookies.get("userDataaInfo");
  const SignupData = Cookies.get("SignupData");
  const CustomerAdded=Cookies.get("customerAdded");
  const [billingCity,setBillingCity] = useState('');
  const [billingAddressInfo, setBillingAddressInfo] = useState('');
  const [billingZip, setBillingZip] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingCountry, setBillingCountry] = useState('USA');
  const addedPayments = Cookies.get("addedPayments");
  const Info=Cookies.get("CustomerInfo");
  const MERCHANT_STORAGE_KEY = "merchantname";
  const merchantname = Cookies.get(MERCHANT_STORAGE_KEY);

  const handleEdit = async (data: any) => {
    setEditData(data);
     setShowCardField(false);
    setFormVisible(true);
    setBillingCity(data.city);
    setBillingAddressInfo(data.address);
    setBillingZip(data.zip);
    setBillingState(data.state);
    setBillingCountry("USA");
    // Populate form fields with existing data
    setValue("firstname", data.firstName);
    setValue("lastname", data.lastName);
    // setValue("phone", data.phone);
    setValue("address1", data.address);
    setValue("address2", data.address2);
    setValue("city", data.city);
    setValue("state", data.state);
    setValue("zip", data.zip);
    setValue("country", "USA");
    setValue("cardNumber", data.cardNumber);
    setValue("expirationDate", data.expirationDate);
    setValue("CVC", data.CVC);
    setValue("profileId", data.profileId);
  };
  const handleDelete = async (profileId: string) => {
     const userConfirmed = window.confirm(
       "Are you sure you want to delete the payment method?"
     );
     if (!userConfirmed) return; 
    const apiData = {
      customerProfileId: user,
      paymentProfileId: profileId,
      
    }
    const baseurl = appConfig.apiPrefix;
    const apiurl = `/onlineOrder/customer/payment`;
    await axios.delete(baseurl + apiurl, {
      data: apiData,
      headers: {
        MID: merchantname,
        Timezone: getCurrentTimezone(),
      },
    });
    window.location.reload();
  };
  const handleAddCard = () => {
    setFormVisible(false);
    reset();
    setShowCardField(true);
  };
  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {

        if (userDataString && Info && !SignupData) {
          const response = JSON.parse(userDataString);
          const responsetwo = JSON.parse(Info);
          if (addedPayments) {
            setUser(response?.customerProfileId);
            setAuth(JSON.parse(addedPayments));
            setPhone(responsetwo.phone);
            setUseremail(responsetwo.email);
          }
          else if (response?.paymentProfiles === null) {
            setPhone(responsetwo.phone);
            setUseremail(responsetwo.email);
          } else {
            setUser(response?.customerProfileId);
            setAuth(response?.paymentProfiles);
            setPhone(responsetwo.phone);
            setUseremail(responsetwo.email);
          }

          if (response["AuthNet Profile Info "]?.profile?.paymentProfiles) {
            const cardsData: {
              // profileId: string;
              cardNumber: string;
              cardType: string;
              expirationDate: string;
              firstName: string;
              lastName: string;
              profileId: string;
              address: string;
              city: string;
              state: string;
              zip: string;
            }[] = auth?.map((card) => ({
              cardNumber: card.payment.creditCard.cardNumber,
              cardType: card.payment.creditCard.cardType,
              expirationDate: card.payment.creditCard.expirationDate,
              firstName: card.billTo.firstName,
              lastName: card.billTo.lastName,
              profileId: card.customerPaymentProfileId,
              address: card.billTo.address,
              city: card.billTo.city,
              state: card.billTo.state,
              zip: card.billTo.zip,
            }));
            setCards(cardsData);
          }
        }
        else if (SignupData && userDataString && CustomerAdded) {
          const response = JSON.parse(SignupData);
          const responsetwo = JSON.parse(userDataString);
          const responsethree = JSON.parse(CustomerAdded);
          if (responsetwo["AuthNet Profile Info "]?.profile?.paymentProfiles) {
            const cardsData: {
              cardNumber: string;
              cardType: string;
              expirationDate: string;
              firstName: string;
              lastName: string;
              profileId: string;
              address: string;
              city: string;
              state: string;
              zip: string;
            }[] = auth?.map((card) => ({
              cardNumber: card.payment.creditCard.cardNumber,
              cardType: card.payment.creditCard.cardType,
              expirationDate: card.payment.creditCard.expirationDate,
              firstName: card.billTo.firstName,
              lastName: card.billTo.lastName,
              profileId: card.customerPaymentProfileId,
              address: card.billTo.address,
              city: card.billTo.city,
              state: card.billTo.state,
              zip: card.billTo.zip,
            }));
            setCards(cardsData);
          }
          setUseremail(
            responsethree.email
          );
          setPhone(
            responsethree.phone
          );
          if (response?.authNetProfileId != null) {
            setUser(response.authNetProfileId);
            setAuth(
              responsetwo["AuthNet Profile Info "]?.profile?.paymentProfiles
            );
          }
        }
        else if (Info && !SignupData) {
          const response = JSON.parse(Info);
          setPhone(response.phone);
          setUseremail(response.email);
        }
        else if (CustomerAdded) {

          const response = JSON.parse(CustomerAdded);
          setPhone(response.phone);
          setUseremail(response.email);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (!user || !auth ||!useremail) {
   
      fetchDataFromAPI();
    }
  }, []);

  useEffect(() => {
    if (auth) {
      const cardsData: {
        cardNumber: string;
        cardType: string;
        expirationDate: string;
        firstName: string;
        lastName: string;
        profileId: string;
        address: string;
        city: string;
        state: string;
        zip: string;
      }[] = auth.map((card) => ({
        cardNumber: card.payment.creditCard.cardNumber,
        cardType: card.payment.creditCard.cardType,
        expirationDate: card.payment.creditCard.expirationDate,
        firstName: card.billTo.firstName,
        lastName: card.billTo.lastName,
        profileId: card.customerPaymentProfileId,
        address: card.billTo.address,
        city: card.billTo.city,
        state: card.billTo.state,
        zip: card.billTo.zip,
      }));
      setCards(cardsData);
    }
  }, [auth]);
  const cleanPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber) {
      return phoneNumber.replace(/\D/g, "");
    } else {
      return null;
    }
  };
const getCurrentTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: {
      profileId: "",
      cardNumber: "",
      firstname: "",
      lastname: "",
      expirationDate: "",
      CVC:"",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "USA",
      zip: "",
    },
  });
 const handleSaveCard = async (data: any) => {
    const cardNumber = data.cardNumber.replace(/\s/g, "");
    const { month: expMonth, year: expYear } = parseExpiration(
      data.expirationDate || ""
    );
    const cvc = data.CVC || "";
    let merchantOpaqueData: { dataDescriptor: string; dataValue: string };
    let basilOpaqueData: { dataDescriptor: string; dataValue: string };
    try {
      await loadAcceptJs();
      if (typeof window.Accept === "undefined") {
        toast.custom(
          (t) => (
            <Transition appear show={t.visible} className="p-4 max-w-md w-full bg-red-100 dark:bg-red-800 shadow-lg rounded-2xl pointer-events-auto ring-1 ring-red-500/50 dark:ring-red-500/10 text-red-900 dark:text-red-200" enter="transition-all duration-150" enterFrom="opacity-0 translate-x-20" enterTo="opacity-100 translate-x-0" leave="transition-all duration-150" leaveFrom="opacity-100 translate-x-0" leaveTo="opacity-0 translate-x-20">
              <p className="block text-base font-semibold leading-none">Payment script did not load</p>
              <div className="border-t border-red-200 dark:border-red-700 my-4" />
              Please try again.
            </Transition>
          ),
          { position: "top-right", id: "nc-product-notify", duration: 3000 }
        );
        return;
      }
      merchantOpaqueData = await tokenizeCardWithAcceptJs(cardNumber, expMonth, expYear, cvc);
      basilOpaqueData = await tokenizeCardWithAcceptJsWithCredentials(cardNumber, expMonth, expYear, cvc, getBasilCredentials());
    } catch (err: any) {
      toast.custom(
        (t) => (
          <Transition
            appear
            show={t.visible}
            className="p-4 max-w-md w-full bg-red-100 dark:bg-red-800 shadow-lg rounded-2xl pointer-events-auto ring-1 ring-red-500/50 dark:ring-red-500/10 text-red-900 dark:text-red-200"
            enter="transition-all duration-150"
            enterFrom="opacity-0 translate-x-20"
            enterTo="opacity-100 translate-x-0"
            leave="transition-all duration-150"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-20"
          >
            <p className="block text-base font-semibold leading-none">
              Payment tokenization failed
            </p>
            <div className="border-t border-red-200 dark:border-red-700 my-4" />
            {err?.message || "Please check card details and try again."}
          </Transition>
        ),
        { position: "top-right", id: "nc-product-notify", duration: 3000 }
      );
      return;
    }
    const paymentInfoAdd = {
      customerProfileId: user,
      merchantDataDescriptor: merchantOpaqueData.dataDescriptor,
      merchantDataValue: merchantOpaqueData.dataValue,
      basilDataDescriptor: basilOpaqueData.dataDescriptor,
      basilDataValue: basilOpaqueData.dataValue,
    };
    const paymentInfoUpdate = {
      customerProfileId: user,
      paymentProfileId: data.profileId,
      merchantDataDescriptor: merchantOpaqueData.dataDescriptor,
      merchantDataValue: merchantOpaqueData.dataValue,
      basilDataDescriptor: basilOpaqueData.dataDescriptor,
      basilDataValue: basilOpaqueData.dataValue,
    };
    const apiData = {
      billingInfo: {
        firstName: data.firstname,
        lastName: data.lastname,
        address: data.billingAddress?.address1 ?? "",
        city: data.billingAddress?.city ?? "",
        state: data.billingAddress?.state ?? "",
        zipCode: data.billingAddress?.zip ?? "",
        country: data.billingAddress?.country ?? "USA",
        addressType: "Billing",
        phone: cleanPhoneNumber(phonee),
      },
      paymentInfo: paymentInfoAdd,
      defaultPaymentProfile: false,
    };
    const apiDataa = {
      billingInfo: {
        firstName: data.firstname,
        lastName: data.lastname,
        address: [data.billingAddress?.address1, data.billingAddress?.address2].filter(Boolean).join(" ") || "",
        city: data.billingAddress?.city ?? "",
        state: data.billingAddress?.state ?? "",
        zipCode: data.billingAddress?.zip ?? "",
        country: data.billingAddress?.country ?? "USA",
        addressType: "Billing",
        phone: cleanPhoneNumber(phonee),
      },
      paymentInfo: paymentInfoUpdate,
      defaultPaymentProfile: false,
    };
    try {
      if (formVisible) {
        const baseurl = appConfig.apiPrefix;
        const apiurl = `/onlineOrder/customer/payment/update`;
       
        const responsePayment = await axios.post(baseurl + apiurl, apiDataa, {
          headers: {
            MID: merchantname,
            Timezone: getCurrentTimezone(),
          },
        });
        if (responsePayment.data.messages.resultCode === "OK") {
          setFormVisible(false);
          reset();
          window.location.reload();
        }
        else {
          toast.custom(
            (t) => (
              <Transition
                appear
                show={t.visible}
                className="p-4 max-w-md w-full bg-red-100 dark:bg-red-800 shadow-lg rounded-2xl pointer-events-auto ring-1 ring-red-500/50 dark:ring-red-500/10 text-red-900 dark:text-red-200"
                enter="transition-all duration-150"
                enterFrom="opacity-0 translate-x-20"
                enterTo="opacity-100 translate-x-0"
                leave="transition-all duration-150"
                leaveFrom="opacity-100 translate-x-0"
                leaveTo="opacity-0 translate-x-20"
              >
                <p className="block text-base font-semibold leading-none">
                  Failed to Save Card
                </p>
                <div className="border-t border-red-200 dark:border-red-700 my-4" />
                We're experiencing difficulties saving your card. Please try
                another card or try again later.
              </Transition>
            ),
            { position: "top-right", id: "nc-product-notify", duration: 3000 }
          );
        }
      }
      else {
        const baseurl = appConfig.apiPrefix;
        const apiurl = `/onlineOrder/customer/payment`;
        const responsePayment = await axios.post(baseurl + apiurl, apiData, {
          headers: {
            MID: merchantname,
            Timezone: getCurrentTimezone(),
          },
        });
        if (!user && responsePayment.data["response:"].customerProfileId) {
          Cookies.set(
            "user",
            responsePayment.data["response:"].customerProfileId
          );
          setUser(responsePayment.data["response:"].customerProfileId);
        }
        setShowCardField(false);
        reset();
        window.location.reload();
      }
    }
    catch (error) {
      toast.custom(
        (t) => (
          <Transition
            appear
            show={t.visible}
            className="p-4 max-w-md w-full bg-red-100 dark:bg-red-800 shadow-lg rounded-2xl pointer-events-auto ring-1 ring-red-500/50 dark:ring-red-500/10 text-red-900 dark:text-red-200"
            enter="transition-all duration-150"
            enterFrom="opacity-0 translate-x-20"
            enterTo="opacity-100 translate-x-0"
            leave="transition-all duration-150"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-20"
          >
            <p className="block text-base font-semibold leading-none">
              Failed to Save Card
            </p>
            <div className="border-t border-red-200 dark:border-red-700 my-4" />
            We're experiencing difficulties saving your card. Please try another
            card or try again later.
          </Transition>
        ),
        { position: "top-right", id: "nc-product-notify", duration: 3000 }
      );
    }
    return false;
  };
useEffect(() => {
  const fetchCustomerProfile = async () => {
    try {
      const apiurlone = `/onlineOrder/customer`;
      let responseAdded: AxiosResponse<any, any>;
const baseurl = appConfig.apiPrefix;
      responseAdded = await axios.get(baseurl + apiurlone, {
        headers: {
          MID: merchantname,
          Timezone: getCurrentTimezone(),
        },
        params: {
          customerProfileId: Number(user.replace(/\D/g, "")), // Query parameter
        },
      });
      if (responseAdded?.data) {
        setUser(responseAdded.data?.customerProfileId);
         Cookies.set(
           "user",
           responseAdded.data?.customerProfileId
         );
        setAuth(responseAdded.data?.paymentProfiles);
      }
    } catch (error) {
      console.error("Error fetching customer profile:", error);
    }
  };
  fetchCustomerProfile();
}, [user]);
 
  return (
    <div>
      <CommonLayout>
        <div className="flex items-start space-x-4 sm:space-x-6">
          <div className="flex-1">
            {auth?.length > 0  &&
            <label
              htmlFor="Credit-Card"
              className="flex items-center space-x-4 sm:space-x-6"
            >
              <div className={`p-2.5 rounded-xl border-2 `}>
                <svg
                  className="w-6 h-6 sm:w-7 sm:h-7"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M2 12.6101H19"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M19 10.28V17.43C18.97 20.28 18.19 21 15.22 21H5.78003C2.76003 21 2 20.2501 2 17.2701V10.28C2 7.58005 2.63 6.71005 5 6.57005C5.24 6.56005 5.50003 6.55005 5.78003 6.55005H15.22C18.24 6.55005 19 7.30005 19 10.28Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 6.73V13.72C22 16.42 21.37 17.29 19 17.43V10.28C19 7.3 18.24 6.55 15.22 6.55H5.78003C5.50003 6.55 5.24 6.56 5 6.57C5.03 3.72 5.81003 3 8.78003 3H18.22C21.24 3 22 3.75 22 6.73Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.25 17.8101H6.96997"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.10986 17.8101H12.5499"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>   
              <p className="font-medium">Debit / Credit Card</p>
            </label>
            }
          </div>
        </div>
        <div className="mt-6 mb-4 space-y-3 sm:space-y-5">
          <div className="p-4 mb-3">
            {auth?.length > 0  ? (
              <div className="p-4 mb-3">
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    card={card}
                    cardType={card.cardType}
                    cardHolderName={`${card.firstName} ${card.lastName}`}
                    cardNumber={card.cardNumber.replace(/\s/g, "")}
                    onEdit={()=>handleEdit(card)}
                    onDelete={()=>handleDelete(card.profileId)}
                  />
                ))}
                {!showCardField && (
                  <button
                    onClick={handleAddCard}
                    className="mt-4 bg-custom-green text-white font-normal py-2 px-4 rounded"
                  >
                    Add Card
                  </button>
                )}
              </div>
            ) : (
              <>
                <h3 className="text-2xl mt-3 text-center">Card not found</h3>
                <button
                  onClick={handleAddCard}
                  className="mt-4 bg-custom-green text-white font-normal py-2 px-4 rounded"
                >
                  Add Card
                </button>
              </>
            )}
            {(showCardField||formVisible) && (
              <form>
                <PaymentForm
                  control={control}
                  errors={errors}
                  handleAddCard={handleAddCard}
                  // setValue={setValue}
                />
                <BillingAddressForm
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  billingCity={billingCity}
                  billingAddressInfo={billingAddressInfo}
                  billingZip={billingZip}
                  billingState={billingState}
                  billingCountry={billingCountry}
                  namespace={"billingAddress"}
                />
                <button
                  type="button"
                  onClick={() => handleSubmit(handleSaveCard)()}
                  className="mt-4 bg-blue-500 text-white font-normal py-2 px-4 rounded"
                >
                  Save
                </button>
              </form>
            )}
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountSavelist;
